import { MonitoringCriteriaItemModel } from '../../../Common/MonitorShared/model/monitoring-criteria-item.model';
import { SearchCriteriaQuerySentimentsEnum } from '../../../api/mentions/enum/search-criteria-query-sentiments.enum';

export class SentimentModel extends MonitoringCriteriaItemModel {
    declare id: SearchCriteriaQuerySentimentsEnum;

    constructor(id: SearchCriteriaQuerySentimentsEnum, name?: string, ) {
        super(name, id);

        if (!name) {
            this.name = this.getLocalizationToken();
        }
    }

    static getAll(): SentimentModel[] {
        return [
            new SentimentModel(SearchCriteriaQuerySentimentsEnum.positive),
            new SentimentModel(SearchCriteriaQuerySentimentsEnum.negative),
            new SentimentModel(SearchCriteriaQuerySentimentsEnum.neutral),
            new SentimentModel(SearchCriteriaQuerySentimentsEnum.notAvailable)
        ];
    }

    private getLocalizationToken(): string {
        return 'Sentiment.' + this.id;
    }
}
